// import '../src/wdyr';

import React from "react";
import ReactDOM from "react-dom";

import App from "../src/App";
import "./application.css";

import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();

document.addEventListener("DOMContentLoaded", () => {
  ReactDOM.render(<App />, document.getElementById("root"));
});
